import type { MessageOrder } from "../../../constants";

export const receivedBubbleStyles: Record<
  MessageOrder | "container" | "status" | "exactTime",
  string
> = {
  container:
    "rounded-xl bg-gray-200 mr-10 relative overflow-x-auto received-bubble-container",
  status: "bottom-2.5 right-2 received-bubble-status",
  first: "rounded-bl-sm received-bubble received-bubble-first",
  middle: "rounded-l-sm received-bubble received-bubble-middle",
  last: "rounded-tl-sm received-bubble received-bubble-last",
  sole: "",
  exactTime:
    "absolute bottom-2.5 right-0 text-sm text-gray-500 z-10 bg-white received-bubble-exact-time",
};

export const sentBubbleStyles: Record<
  MessageOrder | "container" | "status" | "exactTime",
  string
> = {
  container:
    "rounded-xl bg-blue-100 ml-10 relative overflow-x-auto sent-bubble-container",
  status: "bottom-2.5 left-2 send-bubble-status",
  first: "rounded-br-sm send-bubble send-bubble-first",
  middle: "rounded-r-sm send-bubble send-bubble-middle",
  last: "rounded-tr-sm send-bubble send-bubble-last",
  sole: "",
  exactTime:
    "absolute bottom-2.5 left-0 text-sm text-gray-500 z-10 bg-white send-bubble-exact-time",
};
